/**
 * Logix Offline Module — main entry point.
 * Auto-initializes UI, exposes global API.
 */

import { isIndexedDBAvailable } from "./db"
import { triggerManualSync, getSyncStatus } from "./sync"
import { initOfflineUI, showToast, updateSyncBadge } from "./ui"
import { warmCache } from "./cache_warmer"
import { applyBranding } from "./branding"
import { calculateDue } from "./due_calculation"

export function initOffline() {
  if (!isIndexedDBAvailable()) {
    console.warn("[Logix] IndexedDB not available. Offline functionality disabled.")
    return false
  }

  initOfflineUI()

  // Apply cached branding on load
  applyBranding()

  // Expose global API for inline scripts and service worker communication
  window.Logix = window.Logix || {}
  window.Logix.triggerSync = triggerManualSync
  window.Logix.getSyncStatus = getSyncStatus
  window.Logix.showToast = showToast
  window.Logix.updateSyncBadge = updateSyncBadge
  window.Logix.warmCache = warmCache
  window.Logix.calculateDue = calculateDue

  return true
}

// Auto-initialize when DOM is ready
if (typeof document !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initOffline)
  } else {
    initOffline()
  }
}

export * from "./db"
export * from "./sync"
export * from "./ui"
export * from "./due_calculation"
export * from "./cache_warmer"
export * from "./branding"
